import React from 'react';
import PropTypes from 'prop-types';
import { PinIcon } from '@adsk/alloy-react-icon';
import { addressItem, geocoderItemAddress, geocoderItemIcon } from './styles';

const AutocompleteAddressItem = ({ address }) => (
  <div css={addressItem}>
    <PinIcon style={geocoderItemIcon} />
    <span css={geocoderItemAddress}>{address}</span>
  </div>
);

AutocompleteAddressItem.propTypes = {
  address: PropTypes.string.isRequired,
};

export default AutocompleteAddressItem;
